var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrench",
    clipPath: "url(#clip0_127_38509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M22.0234 20C27.5484 20 32.0234 15.525 32.0234 10C32.0234 9.04375 31.8859 8.11875 31.6359 7.2375C31.4422 6.5625 30.6109 6.4125 30.1172 6.90625L25.3172 11.7063C25.1297 11.8938 24.8734 12 24.6109 12H21.0234C20.4734 12 20.0234 11.55 20.0234 11V7.4125C20.0234 7.15 20.1297 6.89375 20.3172 6.70625L25.1172 1.90625C25.6109 1.4125 25.4547 0.58125 24.7859 0.3875C23.9047 0.1375 22.9797 0 22.0234 0C16.4984 0 12.0234 4.475 12.0234 10C12.0234 11.1938 12.2359 12.3438 12.6172 13.4062L1.26719 24.7563C0.473437 25.55 0.0234375 26.6313 0.0234375 27.7563C0.0234375 30.1 1.92344 32 4.26719 32C5.39219 32 6.47344 31.55 7.26719 30.7563L18.6172 19.4062C19.6797 19.7938 20.8297 20 22.0234 20ZM5.02344 25.5C5.42126 25.5 5.80279 25.658 6.0841 25.9393C6.3654 26.2206 6.52344 26.6022 6.52344 27C6.52344 27.3978 6.3654 27.7794 6.0841 28.0607C5.80279 28.342 5.42126 28.5 5.02344 28.5C4.62561 28.5 4.24408 28.342 3.96278 28.0607C3.68147 27.7794 3.52344 27.3978 3.52344 27C3.52344 26.6022 3.68147 26.2206 3.96278 25.9393C4.24408 25.658 4.62561 25.5 5.02344 25.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_38509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.bc5eee38100eb12206ae37e6ff98c208.svg";
export { ForwardRef as ReactComponent };